goog.provide('el8.appchart.visitNote.checklist');

goog.require('el8.data.base');
goog.require('el8.template.appchart.visitNote');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.dom');
goog.require('el8.util.consts');
goog.require('el8.data.model.checklist');
goog.require('el8.appchart.visitNote.saveTemplateDialog');
goog.require('el8.appchart.visitNote.viewTemplatesDialog');
goog.require('el8.data.checklistTemplates');

el8.appchart.visitNote.checklist = function(spec) {

    this._note = spec.note;
    this._form = spec.form;
    this._type = spec.type; // all lower case
    this._container = spec.container;
    this._checklistTrigger = spec.checklistTrigger;
    this._actionsMenu = spec.actionsMenu;
    this._entryHeight = el8.util.consts.DEFAULT_FIELD_HEIGHT;
    this._rightAlign = (spec.rightAlign === true); // defaults to false

    this._templatesMenu = null;
    this._templatesTrigger = spec.templatesTrigger;
    // used to override what happens when user clicks template, if we don't want the default dropdown
    this._templatesTriggerOverrideFn = spec.templatesTriggerOverrideFn;
    this._sectionShowFn = spec.sectionShowFn || null;
    this._isVisitNoteTemplate = spec.isVisitNoteTemplate;

    this._minimized = false;
    this._isInit = false;

    this._lastSavedFieldMap = [];
};

el8.appchart.visitNote.checklist.prototype._init = function() {
    if (this._isInit) { return; }

    el8.data.checklistTemplates.softLoad(null, false); // do sync load

    var defaultChecklist = el8.data.checklistTemplates.getDefaultByType(this._type);
    this._container.empty().html(
        el8.template.appchart.visitNote.detailChecklistForm({
            choices: defaultChecklist ? defaultChecklist.getFieldNames(el8.ptdata.currPatient.getSex()) : [],
            type: this._type,
            isVisitNoteTemplate: this._isVisitNoteTemplate
        })
    );

    var that = this;
    this._checklistTrigger.on('click', function(event) {
        if (!that._minimized) {
            that.minimize();
        } else {
            that.show();
        }
    });
    this._container.on('click', '.clear-trigger',  function(event) {
        that.clear();
    });
    this._container.on('click', '.save-new-trigger',  function(event) {
        var content = that.getContent();
        if (content.isEmpty()) {
            el8.uiwidget.alert("Cannot save an empty form. Please add detail.");
            return false;
        }
        el8.appchart.visitNote.saveTemplateDialog.show(content,
            function() { that._buildTemplateMenu(); }
        );
    });

    this._listenerFn = function() { that._buildTemplateMenu(); };
    el8.data.checklistTemplates.bind('all', this._listenerFn);

    this._initTextareas();

    this._templatesTrigger.on('click', function(event) {
        // if we have an override fn for the template click, we execute that instead
        // of showing the default dropdown menu
        if (that._templatesTriggerOverrideFn) {
            that._templatesTriggerOverrideFn(event);
            return false;
        }

        if (!that._templatesMenu) { that._buildTemplateMenu(); }
        var offsets = !that._rightAlign ? {top: 19, left: 68} : {top:19, left:10};
        that._actionsMenu.display($(this), null, offsets, that._templatesMenu);
        return false;
    });

    this._isInit = true;
};

el8.appchart.visitNote.checklist.prototype._initTextareas = function() {
    var that = this;
    $('textarea', this._container).each(function() {
        var name = $(this).attr('name');
        that._form.addField({
            name: name,
            elt: $(this),
            infoText: ''
        });
    });
    this._container.on('change', 'textarea',  function(e) {
        var self = $(this);
        var name = self.attr('name');
        var key = that._nameToKey(name);
        var infoField = that._form.getInfoField(name);
        that._saveItem(key, infoField);
    });
};

el8.appchart.visitNote.checklist.prototype.show = function(doFocus) {
    if (!this._isInit) { this._init(); }
    doFocus = (doFocus !== false);  // default to true
    this._checklistTrigger.text('Hide empty checklist fields');
    this._container.show();
    $(':input', this._container).each(function(index) {
        $(this).closest('.checklistWrap').show();
        if (index === 0 && doFocus) { $(this).focusFocus(); }
    });
    $('.checklist-buttons', this._container).show();
    this._minimized = false;
    return this;
};

el8.appchart.visitNote.checklist.prototype.minimize = function() {
    if (!this._isInit) { this._init(); }
    var that = this;
    this._checklistTrigger.text('Show all checklist fields');
    var allHidden = true;
    $('textarea', this._container).each(function(index) {
        var name = $(this).attr('name');
        var infoField = that._form.getInfoField(name);
        if (infoField && infoField.getVal()) {
            $(this).closest('.checklistWrap').show();
            allHidden = false;
        } else {
            $(this).closest('.checklistWrap').hide();
        }
    });
    this._minimized = true;
    if (allHidden) {
        $('.checklist-buttons', this._container).hide();
    } else {
        $('.checklist-buttons', this._container).show();
    }
    this._container.show();
    return this;
};

el8.appchart.visitNote.checklist.prototype.clear = function() {
    var that = this;
    var needsResave = false;
    $('textarea', this._container).each(function() {
        var name = $(this).attr('name');
        if ($(this).attr('_saved')) { needsResave = true; }
        that._form.getInfoField(name).setVal('');
        that._form.getInfoField(name).getInputField().height(that._entryHeight);
    });
    if (needsResave) { this.saveAll(); }
    this.show();
    return this;
};

el8.appchart.visitNote.checklist.prototype.destroy = function() {
    el8.data.checklistTemplates.unbind('all', this._listenerFn);
};

el8.appchart.visitNote.checklist.prototype.saveAll = function(async) {
    var that = this;
    var detailObj = this.getContent(true);
    this._note.saveChecklistItems(this._type, detailObj.asFieldMap(true), {
        successCb: function() {
            $('textarea', that._container[0]).attr('_saved', 'true');
            that._lastSavedFieldMap = that.getContent().asFieldMap();
        },
        async: async
    });
};

el8.appchart.visitNote.checklist.prototype.populate = function(checklist, doSave) {
    if (!checklist) { return; }
    this._populateDict(checklist.asObj(), checklist.getHighlightedFields(), doSave);
    if (doSave === false) {
        // populate the currently saved state, so isDirty ought to be false rn
        this._lastSavedFieldMap = this.getContent().asFieldMap();
    }
};

el8.appchart.visitNote.checklist.prototype.populateTemplate = function(checklist) {
    if (this._sectionShowFn) { this._sectionShowFn(); }
    this.populate(checklist, true);
};

el8.appchart.visitNote.checklist.prototype.populateFromPrevNote = function() {
    var that = this;
    el8.appservice.notifier.notify('Finding past ' + that._type.toUpperCase() + ' templates...');
    $.el8_ajax({
        type: 'GET',
        url: el8.service.urls.get('prevChecklistTemplate', [that._note.getId(), that._type]),
        success: function(checklistDict) {
            if (!checklistDict) {
                el8.appservice.notifier.notify('No previous ' + that._type.toUpperCase() + ' templates found.');
                return;
            }
            el8.appservice.notifier.clear();
            if (that._sectionShowFn) { that._sectionShowFn(); }
            that._populateDict(checklistDict, [], true);
        }
    });
};

el8.appchart.visitNote.checklist.prototype._populateDict = function(checklistDict, highlightedFields, doSave) {

    if (!checklistDict) { return; }
    if (!highlightedFields) { highlightedFields = []; }
    doSave = (doSave !== false); // default to true
    this.show();
    for (var key in checklistDict) {
        if (checklistDict.hasOwnProperty(key)) {
            var isHighlighted = highlightedFields.indexOf(key) !== -1;
            this._populateItem(key, checklistDict[key], isHighlighted, doSave);
        }
    }
    this.minimize();
    if (doSave) { this.saveAll(undefined); }
};


el8.appchart.visitNote.checklist.prototype._populateItem = function(key, val, isHighlighted, doSave) {
    // TODO In the future, if we run into a key we don't have displaying, then we should
    // add that field (rather than now, we just ignore)
    doSave = (doSave !== false); // default to true
    if (val) {
        var infoField = this._form.getInfoField(this._keyToName(key));
        if (infoField) {
            // If we are not saving, then these are values that have already been saved
            if (!doSave) { infoField.getInputField().attr('_saved', 'true'); }
            // Append template value to end of field
            infoField.setVal(
                (infoField.getVal() ? infoField.getVal()+',' : '') + val);

            if (isHighlighted) {
                infoField.getInputField().addClass('el8BlueHighlightList');
            } else {
                infoField.getInputField().removeClass('el8BlueHighlightList');
            }
        }
        return infoField;
    }
    return null;
};

el8.appchart.visitNote.checklist.prototype._saveItem = function(key, infoField) {
    // Only do save if have value in the field OR if field has previously been saved
    var that = this;
    if (infoField) {
        var $input = infoField.getInputField();
        var $item = $input.closest('.checklist-item');
        var index = $item.attr('data-index')*1;
        if (infoField.getVal() || $input.attr('_saved')) {
            var obj = {
                name: key,
                value: infoField.getVal(),
                sequence: index
            };
            that._note.saveChecklistItem(that._type, obj, {
                successCb: function() {
                    $input.attr('_saved', "true");
                    // always remove the highlight since server should have marked
                    // editedByVnt as false
                    $input.removeClass('el8BlueHighlightList');
                    that._lastSavedFieldMap = that.getContent().asFieldMap();
                }
            });
        }
    }
};

el8.appchart.visitNote.checklist.prototype.addEntry = function(key, val, doSave) {
    doSave = (doSave !== false); // default to true
    this.show();
    // by default no highlight when added the entry manually instead of populated
    // from server side since visit note is applied on server side
    var infoField = this._populateItem(key, val, false, doSave);
    this.minimize();
    if (doSave) { this._saveItem(key, infoField); }
};

el8.appchart.visitNote.checklist.prototype.getContent = function(full) {
    var that = this;
    var result = el8.data.model.checklist({type: this._type});
    $('textarea', this._container).each(function(index) {
        var name = $(this).attr('name');
        var infoField = that._form.getInfoField(name);
        if (infoField && (full || infoField.getVal())) {
            var key = that._nameToKey($(this).attr('name'));
            result.setFieldByName(key, infoField.getVal(), index);
        }
    });
    return result;
};

el8.appchart.visitNote.checklist.prototype.isDirty = function() {
    // Unlike listeditor and MLEs, checklists are populated in bulk by VNs which call .populate
    // this which calls .saveAll which marks this widget clean. No need for addional clean
    // marking for init
    var saved = this._lastSavedFieldMap;
    var content = this.getContent();
    var curr = content.asFieldMap();
    var dirty = false;

    _.each(curr, function(obj, idx) {
        if (!saved[idx] || !_.isEqual(obj, saved[idx])) { dirty = true; }
    });
    return dirty;
};

el8.appchart.visitNote.checklist.prototype.saveIfDirty = function() {
    if (this.isDirty()) { this.saveAll(false); }
};

el8.appchart.visitNote.checklist.prototype._buildTemplateMenu = function() {
    var menu = [];
    var that = this;
    var genTemplateFn = function(template) {
        return function() {
            that.populateTemplate(template);
        };
    };
    el8.data.checklistTemplates.getTop(this._type, 10).map(function(template) {
        menu.push({
            actionText: template.getName(),
            actionFn: genTemplateFn(template)
        });
    });
    if (el8.data.checklistTemplates.allType(this._type).length > 0) {
        menu.push({
            actionText: 'See All Templates',
            actionFn: function() {
                el8.appchart.visitNote.viewTemplatesDialog.show(that._type);
            }
        });
    }
    this._templatesMenu = menu;
};

el8.appchart.visitNote.checklist.prototype._nameToKey = function(name) {
    return name.split('-')[1];
};
el8.appchart.visitNote.checklist.prototype._keyToName = function(key) {
    return this._type + '-' + key;
};

el8.appchart.visitNote.checklist.prototype.getJsonData = function() {
    var data = {};
    var detailObj = this.getContent(true);
    var fieldMap = detailObj.asFieldMap(true);

    fieldMap.forEach(function(field) {
        if (field.value) {
            data[field.name.toUpperCamel()] = field.value;
        }
    });

    return data;
};
